module.exports = __webpack_public_path__ + "assets/images/games/bg_track_mountain.3de81f4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/games/carrot-game/bg_track_mountain.png
// module id = 1635
// module chunks = 1